<script lang="ts">
    import UserForm from "./UserForm.svelte";
    import Modal from "../Modal/Modal.svelte";
    import {push} from "svelte-spa-router";

    let gestionnaire = {
        withClientInput: true
    }

    let userCreationStatus:boolean = false;
    function handleForm(event) {
        userCreationStatus = event.detail.requestStatus;
    }

    function onCloseSuccessDemand() {
        push('/');
    }
</script>

<h2 class="title is-2 has-text-centered mb-6">Demande de création de compte</h2>

{#if userCreationStatus}
    <div>
        <Modal title="Demande de création réussie" type="validation">
            <svelte:fragment slot="button">
                <button on:click={onCloseSuccessDemand} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
            <svelte:fragment slot="comment">
                <p class="has-text-centered">Vous recevrez prochainement un email de la part de Chrono Chape pour vous prévenir de la création de votre compte.</p>
            </svelte:fragment>
            <svelte:fragment slot="buttons-container">
                <button on:click={onCloseSuccessDemand} class="button-close button is-info">Fermer</button>
            </svelte:fragment>
        </Modal>
    </div>
{/if}

<UserForm gestionnaire={gestionnaire} on:submittedForm={handleForm}/>